import React, { FC, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { BUTTON_TYPES } from '@savgroup-front-common/constants';
import { SwipeableDrawer } from '@savgroup-front-common/core/src/atoms/SwipeableDrawer';
import {
  DIRECTION,
  DRAWER_SIZE,
} from '@savgroup-front-common/core/src/atoms/SwipeableDrawer/SwipeableDrawer';
import { safeFormattedIntlString } from '@savgroup-front-common/core/src/formatters';
import {
  MenuHamburgerCloseIcon,
  ReversioIcon,
} from '@savgroup-front-common/core/src/protons/icons';

import { ROUTES } from '../../../../../constants/routing';
import { $HeaderLogo } from '../../Header.styles';
import messages from '../../messages';

import { $Header, $MenuHamburger } from './MinimalHeaderNewUi.styles';
import { MinimalHeaderSidebar } from './MinimalHeaderSidebar/MinimalHeaderSidebar';

export const MinimalHeaderNewUi: FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const theme = useTheme();
  const iconColor = theme.colors.white;
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <>
      <$Header>
        <$MenuHamburger
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          type={BUTTON_TYPES.BUTTON}
        >
          <MenuHamburgerCloseIcon color={iconColor} />
        </$MenuHamburger>

        <$HeaderLogo>
          <Link
            to={ROUTES.HOME}
            aria-label={safeFormattedIntlString(messages.goToHomePage)}
          >
            <ReversioIcon color="#fff" />
          </Link>
        </$HeaderLogo>
      </$Header>

      <SwipeableDrawer
        hasCloseButton={false}
        hasPadding={false}
        isOpen={isMenuOpen}
        direction={DIRECTION.RIGHT}
        size={DRAWER_SIZE.X_SMALL}
        onClose={() => setIsMenuOpen(false)}
      >
        <MinimalHeaderSidebar onClose={() => setIsMenuOpen(false)} />
      </SwipeableDrawer>
    </>
  );
};
